/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Lembaga_D3dInputs */

const en_mk_sol_lembaga_d3d = /** @type {(inputs: Mk_Sol_Lembaga_D3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The draft is built from what was actually recorded, not from memory at quarter’s end.`)
};

const id_mk_sol_lembaga_d3d = /** @type {(inputs: Mk_Sol_Lembaga_D3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draf disusun dari data yang benar-benar tercatat, bukan dari ingatan di akhir kuartal.`)
};

/**
* | output |
* | --- |
* | "The draft is built from what was actually recorded, not from memory at quarter’s end." |
*
* @param {Mk_Sol_Lembaga_D3dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_lembaga_d3d = /** @type {((inputs?: Mk_Sol_Lembaga_D3dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Lembaga_D3dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_lembaga_d3d(inputs)
	return en_mk_sol_lembaga_d3d(inputs)
});